<template>
  <v-app id="inspire">
    <Navbar v-if="existeUsuario"/>
    
    <v-content style="padding: 0 15px;">
        <router-view style="padding: 64px 0 0"/>
    </v-content>
    <Dialog v-if="existeUsuario && usuario.rol == 'SOLICITAR'"/>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar';
import Dialog from './components/Dialog';
import { mapGetters, mapState } from 'vuex';

export default {
    components: {
      Navbar,
      Dialog,
    },
    computed: {
      ...mapState(['usuario']),
      ...mapGetters(['existeUsuario'])
    },
  }
</script>